import {BaseController} from '@mapsight/core/lib/base/controller';
import {baseReducer} from '@mapsight/core/lib/base/reducer';

import {navPosition} from '../../mapsight-glue/routing/nav-pos';

import {
	AUDIOPLAYER_PAUSE,
	AUDIOPLAYER_START,
	SET_HEART,
	SET_HEARTS_FROM_BROWSER,
	setHeartsFromBrowser,
} from './actions';

// we will need a place to store
export const STADE = 'STADE';

/** @typedef {Record<any, unknown> & {[STADE]: StadeState}} RootState */

/** @typedef {{
 *   audioplayer: AudioplayerState,
 *   navigation: {
 *     open: boolean,
 *   },
 *   hearts: Record<string, Record<string, {heart: boolean}>>,
 *   ratings: {
 *     authorName: null | string,
 *     authorToken: null | string,
 *   },
 * }} StadeState */

/** @typedef {{
 *   state: "playing" | "paused",
 * }} AudioplayerState */

export const defaultStadeState = /** @type {StadeState} */ ({
	audioplayer: {
		state: "paused",
	},
	navigation: {
		open: false,
	},
	language: {
		open: false,
	},
	// K-V of K-V
	// hearts[app.uri][poi.id].heart : boolean
	hearts: {
	},
});

const heartsStorageKey = appUri => `stade-hearts-${appUri}`;

let _magic = null;

/**
 * @param {StadeState} state
 * @param {any} action
 * @returns {StadeState}
 */
function stadeReducer(state, action) {
	switch (action.type) {
		case AUDIOPLAYER_START: return {
			...state,
			audioplayer: {
				...state.audioplayer,
				state: "playing",
			},
		};

		case AUDIOPLAYER_PAUSE: return {
			...state,
			audioplayer: {
				...state.audioplayer,
				state: "paused",
			},
		};

		case SET_HEARTS_FROM_BROWSER: return {
			... state,
			hearts: {
				...state.hearts,
				[action.appUri]: action.value
			},
		};

		case SET_HEART:
			if (typeof window !== 'undefined') {
				const navPos = navPosition(_magic, window.location.pathname, window.location.state);
				if(navPos.app) {
					window.localStorage.setItem(heartsStorageKey(action.appUri), JSON.stringify({
						...state.hearts[action.appUri],
						[action.poiId]: {heart: !!action.value},
					}));
				}
			}
			return {
				... state,
				hearts: {
					...state.hearts,
					[action.appUri]: {
						...state.hearts[action.appUri],
						[action.poiId]: {heart: !!action.value},
					}
				}
			};

		default: return state;
	}
}

export class StadeController extends BaseController {
	constructor(controllerName, magic) {
		super(controllerName);
		StadeController.setMagic(magic);

	}

	init() {
		if(typeof window !== 'undefined') {
			const navPos = navPosition(_magic, window.location.pathname, window.location.state);
			if(navPos.app) {
				const storage = window.localStorage.getItem(heartsStorageKey(navPos.app.uri));
				if(storage) {
					try {
						this.dispatch(setHeartsFromBrowser(navPos.app.uri, JSON.parse(storage)));
					} catch (ex) {
						console.error('Could not read hearts from Browser Storage', {ex, storage});
					}
				}
			}
		}
	}

	static setMagic(magic) {
		_magic = magic;
	}

	/**
	 * @param {undefined | StadeState} state
	 * @returns {StadeState}
	 */
	reduce(
		state = defaultStadeState,
		action,
		_globalState,
	) {
		return baseReducer(
			stadeReducer(state, action),
			action,
		);
	}
}
